/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const shipmentStatusTypes = {
  noPendingAction: 'NO_PENDING_ACTION',
  pendingShipment: 'PENDING_SHIPMENT',
  processing: 'PROCESSING',
  delivered: 'DELIVERED',
  shipped: 'SHIPPED',
  pickedUp: 'PICKED UP',
  complete: 'COMPLETE',
  inStorePicked: 'IN_STORE_PICKED',
  removed: 'REMOVED',
  return: 'RETURN',
};

export const orderStatusTypes = {
  shipped: 'shipped',
  return: 'return',
};
